
export default {
    async asyncData(context) {
        const { $strapi, route } = context;
        const path = route.path;

        const pageInfo = await $strapi.getEntries({
            contentType: 'page-infos',
            filters: {
                scope: {
                    $eq: path,
                },
            },
            populate: ['meta', 'meta.ogImage'],
        });

        if (pageInfo.data && pageInfo.data.length && pageInfo.data[0] && pageInfo.data[0].attributes.meta?.data?.attributes) {
            return {
                meta: pageInfo.data[0].attributes.meta.data.attributes,
            };
        }

        return {
            meta: {},
        };
    },
    data() {
        return {
            breadCrumbs: {
                crumbs: [
                    {
                        category_name: this.$t('content.breadcrumbs.index'),
                        category_url_path: '/',
                        directLink: true,
                    },
                    {
                        category_name: this.$t('content.breadcrumbs.aboutus'),
                        category_url_path: '/yrityksesta',
                        directLink: true,
                    },
                ],
                product: this.$t('content.breadcrumbs.forms'),
            },
            forms: null,
        };
    },
    async fetch() {
        const forms = await this.$strapi.getEntries({
            contentType: 'listed-links',
            filters: {
                scope: {
                    $eq: '/yrityksesta/lomakkeet',
                },
            },
        });
        if (forms.data && forms.data.length) {
            this.forms = forms.data;
        }
    },
    head() {
        const meta = [];

        if (this.meta.title) {
            meta.push({
                hid: 'title',
                name: 'title',
                content: this.meta.title,
            });
        }

        if (this.meta.ogTitle) {
            meta.push({
                hid: 'og:title',
                name: 'og:title',
                content: this.meta.ogTitle,
            });
        }

        if (this.meta.ogDescription) {
            meta.push({
                hid: 'og:description',
                name: 'og:description',
                content: this.meta.ogDescription,
            });
            meta.push({
                hid: 'description',
                name: 'description',
                content: this.meta.ogDescription,
            });
        }

        if (this.meta.keywords) {
            meta.push({
                hid: 'keywords',
                name: 'keywords',
                content: this.meta.keywords,
            });
        }

        if (this.meta.ogImage?.data?.attributes?.url) {
            meta.push({
                hid: 'og:image',
                name: 'og:image',
                content: this.meta.ogImage?.data?.attributes?.url,
            });
        }

        return {
            title: this.$t('content.title.forms'),
            meta,
        };
    },
};
